/* ==========================================================================
   Cart Buttons Fix (standalone, does NOT depend on theme.js cartMarkup)
   Handles: quantity + / - and remove (trash) buttons
   Uses Shopify's native Ajax Cart API directly, so it can never break
   due to subtotal/markup issues elsewhere in the theme.
   ========================================================================== */
(function () {
  var isUpdating = false;

  function getQtyInput(button) {
    var wrapper = button.closest('.js-qty__wrapper');
    return wrapper ? wrapper.querySelector('.js-qty__num') : null;
  }

  function updateCartCountBadges(itemCount) {
    document.querySelectorAll('[data-cart-count], .cart-count, .js-cart-count').forEach(function (el) {
      el.textContent = itemCount;
    });
  }

  // Refresh the whole item list + count from Shopify's cart state,
  // WITHOUT touching or requiring any subtotal element to exist.
  function refreshCartDisplay() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCountBadges(cart.item_count);

        // Sync each visible qty input with actual cart state (in case of stock clamps)
        cart.items.forEach(function (line) {
          var input = document.querySelector('.js-qty__num[data-id="' + line.key + '"]');
          if (input) input.value = line.quantity;
        });

        // Remove DOM rows for items no longer in cart
        document.querySelectorAll('.cart__item[data-key]').forEach(function (row) {
          var key = row.getAttribute('data-key');
          var stillExists = cart.items.some(function (line) { return line.key === key; });
          if (!stillExists) {
            row.remove();
          }
        });

        // If cart is now empty, let the theme show its own empty state if it has one
        if (cart.item_count === 0) {
          document.body.classList.add('cart-is-empty');
        } else {
          document.body.classList.remove('cart-is-empty');
        }

        return cart;
      });
  }

  function changeItemQuantity(key, quantity) {
    if (isUpdating) return;
    isUpdating = true;

    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { return refreshCartDisplay(); })
      .catch(function (err) { console.error('Cart update failed:', err); })
      .finally(function () { isUpdating = false; });
  }

  document.addEventListener('click', function (e) {
    var plusBtn = e.target.closest('.js-qty__adjust--plus');
    var minusBtn = e.target.closest('.js-qty__adjust--minus');
    var removeBtn = e.target.closest('.cart__remove, .js-qty__remove');

    if (plusBtn) {
      e.preventDefault();
      var input = getQtyInput(plusBtn);
      if (!input) return;
      var newQty = (parseInt(input.value, 10) || 0) + 1;
      input.value = newQty;
      changeItemQuantity(input.getAttribute('data-id'), newQty);
    }

    if (minusBtn) {
      e.preventDefault();
      var input2 = getQtyInput(minusBtn);
      if (!input2) return;
      var newQty2 = Math.max(0, (parseInt(input2.value, 10) || 0) - 1);
      input2.value = newQty2;
      changeItemQuantity(input2.getAttribute('data-id'), newQty2);
    }

    if (removeBtn) {
      e.preventDefault();
      var key = removeBtn.getAttribute('data-key');
      if (!key) return;
      changeItemQuantity(key, 0);
    }
  });

  // Also handle manual typing into the qty input directly
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('js-qty__num')) {
      var input = e.target;
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = qty;
      changeItemQuantity(input.getAttribute('data-id'), qty);
    }
  });
})();
